import styled, { css } from 'styled-components';

const alignVerticallyMap = {
  start: 'flex-start',
  center: 'center',
  end: 'flex-end',
};

export const Wrapper = styled.div<{
  $gap: number;
  $alignRight: boolean;
  $alignVertically: 'start' | 'center' | 'end';
}>`
  display: flex;
  gap: ${(props) => props.$gap}px;
  align-items: ${(props) => alignVerticallyMap[props.$alignVertically]};

  ${(props) =>
    props.$alignRight &&
    css`
      justify-content: flex-end;
    `}
`;

export const Spacer = styled.div`
  flex-grow: 1;
`;
